import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import isNumeric from 'validator/lib/isNumeric';
import isEmpty from 'validator/lib/isEmpty';
import SendIcon from '@material-ui/icons/Send';

import coinImageTier1 from 'images/chat/single-coin.png';
import giftIconUrl from 'images/performerVideo/icon-gift-1.png';
import Button from 'components/Button/Button';
import { translate } from 'services/i18nService';
import TippingService from 'services/TippingService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import ProfileStore from 'stores/ProfileStore';
import PaymentStore from 'stores/PaymentStore';
import { generateID } from 'utils/helpers';

import styles from './index.css';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);
// eslint-disable-next-line no-magic-numbers
const tippingValues = [5, 10, 25, 50, 100];

const IDS = {
  prefix: 'LLlo0o22',
  element: 'PostShowTip',
  tip: 'tip',
  toggleCustomTip: 'toggleCustomTip',
  customInputField: 'customInputField',
  sendCustomTip: 'sendCustomTip',
  sendGift: 'sendGift',
  skipBtn: 'skipBtn',
};
const makeId = generateID(IDS.prefix, IDS.element);

const PostShowTip = (props) => {
  const [customTipValue, setCustomTipValue] = useState(null);
  const { profileName } = ProfileStore;
  const { openBuyGiftsModal, showBuyTokensModal, handleSkip } = props;
  const { sendPrivateTip } = TippingService;

  const handleTipping = useCallback((tipAmount) => () => {
    const data = {
      tipAmount,
      receiver: profileName,
      successCb: handleSkip,
      message: '',
    };
    if (PaymentStore.balance < tipAmount) {
      showBuyTokensModal();
    } else {
      sendPrivateTip(data);
    }
  }, [handleSkip, profileName, sendPrivateTip, showBuyTokensModal]);

  const handleCustomTipChange = useCallback((e) => {
    const { value } = e.target;

    if (parseInt(value, 10) === 0) {
      e.preventDefault();
    } else if (isNumeric(value, { 'no_symbols': true }) || isEmpty(value)) {
      setCustomTipValue(value);
    }
  }, []);

  return (
    <div className={styles.wrapper}>
      <img
        alt="avatar"
        className={styles.profilePic}
        src={`${BASE_URL}/avatar/user/60x60/${profileName}.jpg`}
      />
      <p className={styles.description}>
        {translate('v2profile.say.thank.you', { 0: `<b>${profileName}</b>` })}
      </p>
      <div className={styles.tokenWrap}>
        <img
          alt="single token"
          className={styles.icon}
          src={coinImageTier1}
        />
        <span>{translate('v2profile.send.tip')}</span>
      </div>
      <div className={styles.tippingWrapper}>
        {tippingValues.map((value) => (
          <Button
            key={value}
            className={styles.tippingButton}
            colour="orange"
            label={value}
            onClick={handleTipping(value)}
          />
        ))}
        <div className={styles.customTipWrapper}>
          <input
            autoComplete="off"
            className={styles.textfieldRoot}
            id={makeId(IDS.customInputField)}
            placeholder={translate('v2profile.send.custom.tip.label')}
            value={customTipValue}
            onChange={handleCustomTipChange}
          />
          <Button
            className={styles.sendCustomTip}
            disabled={!customTipValue}
            icon={<SendIcon />}
            id={makeId(IDS.sendCustomTip)}
            onClick={handleTipping(customTipValue)}
          />
        </div>
      </div>
      <div className={styles.giftWrapper}>
        <img
          alt="single token"
          className={styles.icon}
          src={giftIconUrl}
        />
        <span>{translate('v2profile.button.sendGift')}</span>
      </div>
      <Button
        className={styles.actionButtons}
        colour="orange"
        id={makeId(IDS.sendGift)}
        label={translate('v2profile.button.sendGift')}
        onClick={openBuyGiftsModal}
      />
      <button
        className={styles.skipBtn}
        id={makeId(IDS.skipBtn)}
        onClick={handleSkip}
      >
        {translate('v2profile.feedback.skip')}
      </button>
    </div>
  );
};

PostShowTip.propTypes = {
  handleSkip: PropTypes.func,
  openBuyGiftsModal: PropTypes.func,
  showBuyTokensModal: PropTypes.func,
};

PostShowTip.defaultProps = {
  handleSkip: () => undefined,
  openBuyGiftsModal: () => undefined,
  showBuyTokensModal: () => undefined,
};

export default observer(PostShowTip);
